<script setup lang="ts">
import { computed, ref } from 'vue'

import LineIcon from '@/components/Icons/LineIcon.vue'
import TelegramIcon from '@/components/Icons/TelegramIcon.vue'
import WeChatIcon from '@/components/Icons/WeChatIcon.vue'
import BaseModal from '@/components/modals/BaseModal.vue'
import { getEnv } from '@/utils/environmentService'
import { getCookie } from '@/utils/utils'

const showModal = ref(false)

const env = getEnv()

const country = computed(() => {
  return getCookie('country') || ''
})

const qrCode = computed(() => {
  if (env === 'cn' || env === 'hk') {
    return 'wechat'
  } else if (country.value === 'TH') {
    return 'line'
  } else if (country.value === 'KR') {
    return 'telegram'
  }
  return ''
})

const disableBodyScroll = () => {
  document.body.style.overflow = 'hidden'
}

const toggleModal = () => {
  showModal.value = !showModal.value
  disableBodyScroll()
}
</script>

<template>
  <li
    v-if="qrCode === 'wechat'"
    class="pl-2.5 h-full items-center gap-2.5 text-white flex max-[345px]:hidden"
    @click="toggleModal()"
  >
    <WeChatIcon></WeChatIcon>
    Wechat
  </li>
  <li
    v-if="qrCode === 'telegram'"
    class="pl-2.5 h-full items-center gap-2.5 text-white flex max-[345px]:hidden"
    @click="toggleModal()"
  >
    <TelegramIcon></TelegramIcon>
    Telegram
  </li>
  <li
    v-if="qrCode === 'line'"
    class="pl-2.5 h-full items-center gap-2.5 text-white flex max-[345px]:hidden"
    @click="toggleModal()"
  >
    <LineIcon></LineIcon>
    Line
  </li>
  <BaseModal v-model="showModal">
    <div class="bg-white m-12">
      <div class="w-100">
        <img v-if="qrCode === 'line'" alt="" loading="lazy" src="/assets/line-qr.webp" />
        <img v-if="qrCode === 'telegram'" alt="" loading="lazy" src="/assets/telegram-qr.webp" />
        <img v-if="qrCode === 'wechat'" alt="" loading="lazy" src="/assets/wechat-qr.svg" />
      </div>
    </div>
  </BaseModal>
</template>

<style scoped lang="sass"></style>
